<!--
 * @Author: Lemon C
 * @Date: 2024-08-06 10:44:37
 * @LastEditTime: 2024-08-06 13:22:40
-->
<template>
    <div class="sup-next-docs">
        <div class="jump-left-box" v-if="next_jump_left_obj && next_jump_left_obj.id.length" @click="next_jump_active(0)">
            <el-icon><ArrowLeft /></el-icon>
            <span>{{ `上一篇：` + next_jump_left_obj.name }}</span>
        </div>
        <div class="jump-right-box" v-if="next_jump_right_obj && next_jump_right_obj.id.length" @click="next_jump_active(1)">
            <span>{{ `下一篇：` + next_jump_right_obj.name }}</span>
            <el-icon><ArrowRight /></el-icon>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
import { useMessageStore } from '../../stores/message';

const message_store = useMessageStore();

const props = defineProps({
    next_jump_curr_tree_node_id: String, //当前目录树节点id
});

const next_jump_left_obj = ref(null);
const next_jump_right_obj = ref(null);
const next_treeList = ref([]);

watch(
    () => props.next_jump_curr_tree_node_id,
    (val) => {
        handleNextData();
    }
);

onMounted(() => {
    message_store.addMessageHandler(message_store.M_E_TREE_LIST_UPDATE, m_e_tree_list_update);
});

onBeforeUnmount(() => {
    message_store.removeMessageHandler(message_store.M_E_TREE_LIST_UPDATE, m_e_tree_list_update);
});

// MARK Click 跳转
const next_jump_active = (type) => {
    if (type == 1) {
        message_store.sendMessage(message_store.M_E_TREE_AUTO_SEL, { treeId: next_jump_right_obj.value.id });
    } else {
        message_store.sendMessage(message_store.M_E_TREE_AUTO_SEL, { treeId: next_jump_left_obj.value.id });
    }
};

// MARK Message消息通知  目录树点击
const m_e_tree_list_update = (evented) => {
    next_treeList.value = evented.treeList;
    handleNextData();
};

// MARK Handle 处理前后文章数据
const handleNextData = () => {
    let unfold_tree_list = unfold_tree_node(next_treeList.value);
    let find_obj = unfold_tree_list.find((item) => item.id === props.next_jump_curr_tree_node_id);
    let find_index = unfold_tree_list.findIndex((item) => item.id === props.next_jump_curr_tree_node_id);
    if (!find_obj) return;
    if (find_index === 0) {
        next_jump_left_obj.value = null;
        next_jump_right_obj.value = unfold_tree_list[find_index + 1] ? unfold_tree_list[find_index + 1] : null;
    } else if (find_index === unfold_tree_list.length - 1) {
        next_jump_left_obj.value = unfold_tree_list[find_index - 1] ? unfold_tree_list[find_index - 1] : null;
        next_jump_right_obj.value = null;
    } else {
        next_jump_left_obj.value = unfold_tree_list[find_index - 1] ? unfold_tree_list[find_index - 1] : null;
        next_jump_right_obj.value = unfold_tree_list[find_index + 1] ? unfold_tree_list[find_index + 1] : null;
    }
};

// MARK Tree 展开树状数据
const unfold_tree_node = (treeList) => {
    let unfoldList = [];
    for (let i = 0; i < treeList.length; i++) {
        const node = treeList[i];

        if (node.subCatalogs && node.subCatalogs.length > 0) {
            let nodeChildrenUnfoldList = unfold_tree_node(node.subCatalogs);
            unfoldList = unfoldList.concat(nodeChildrenUnfoldList);
        } else {
            unfoldList.push(node);
        }
    }
    return unfoldList;
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-next-docs {
    position: relative;
    display: flex;
    flex-shrink: 0;
    height: 60px;

    .jump-left-box {
        left: 0;
    }

    .jump-right-box {
        right: 0;
        justify-content: flex-end;
    }

    .jump-right-box,
    .jump-left-box {
        position: absolute;
        top: 0;
        height: 30px;
        width: 50%;
        display: flex;
        align-items: center;
        cursor: pointer;

        span {
            max-width: 80%;
            color: var(--color-main-text-secondary);
            font-size: 14px;
            font-weight: 500;
            line-height: 22px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 10px;
        }
        i {
            color: var(--color-main-text-primary);
            font-size: 20px;
        }
    }
}
</style>
